// The title the page's HTML was served with (the prerender wrote it). English
// pages get a translated title; switching back restores this one. A title we
// never replaced is left alone, so Bosnian pages behave exactly as before.
let original = null;
let replaced = false;

export function rememberOriginalTitle(title) {
	original = title;
}

export function setTranslatedTitle(doc, title) {
	doc.title = title;
	replaced = true;
}

export function restoreOriginalTitle(doc) {
	if (!replaced || original === null) return;
	doc.title = original;
	replaced = false;
}
